
import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { ClientNewsAlert } from "../types";
import { NewsMonitoringDisabled } from "./news-alerts/NewsMonitoringDisabled";
import { NewsAlertsHeader } from "./news-alerts/NewsAlertsHeader";
import { NewsAlertsFilters } from "./news-alerts/NewsAlertsFilters";
import { NewsAlertItem } from "./news-alerts/NewsAlertItem";
import { NoNewsAlerts } from "./news-alerts/NoNewsAlerts";
import { useNewsAlertActions } from "@/hooks/useNewsAlertActions"; // New import

interface ClientNewsAlertsTabProps {
  clientId: string; // clientId is not used in this component anymore after refactoring, but keeping it for now if it might be needed by parent or future logic.
  newsAlerts: ClientNewsAlert[];
  newsMonitoringEnabled: boolean;
  onUpdate: () => void;
}

export const ClientNewsAlertsTab = ({ 
  newsAlerts = [], 
  newsMonitoringEnabled,
  onUpdate 
}: ClientNewsAlertsTabProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);

  const { markAsRead, markAsUnread } = useNewsAlertActions({ onUpdate }); // Use the new hook

  const filteredAlerts = newsAlerts.filter(alert => {
    const matchesSearch = alert.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         (alert.content && alert.content.toLowerCase().includes(searchTerm.toLowerCase()));
    const matchesReadFilter = showUnreadOnly ? !alert.is_read : true;
    return matchesSearch && matchesReadFilter;
  });

  // markAsRead and markAsUnread functions are now provided by the hook

  if (!newsMonitoringEnabled) {
    return <NewsMonitoringDisabled />;
  }

  return (
    <Card>
      <NewsAlertsHeader alertsCount={newsAlerts.length} />
      <CardContent className="space-y-4">
        <NewsAlertsFilters 
          searchTerm={searchTerm}
          onSearchTermChange={setSearchTerm}
          showUnreadOnly={showUnreadOnly}
          onShowUnreadOnlyChange={setShowUnreadOnly}
        />

        {filteredAlerts.length === 0 ? (
          <NoNewsAlerts isFiltering={searchTerm !== "" || showUnreadOnly} />
        ) : (
          <div className="space-y-4">
            {filteredAlerts.map((alert) => (
              <NewsAlertItem 
                key={alert.id} 
                alert={alert}
                onMarkAsRead={markAsRead}
                onMarkAsUnread={markAsUnread}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
